import { Box, Grid } from '@mui/material';
import { Condition } from '../types/MedicalHealthInformation';
import {
  ALREADY_ANSWERED,
  MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME
} from '../constants/constants';
import { useMedicalHealthInformationContext } from '../Context';
import Card from './Card';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranchCondition = () => {
  const { setActiveStep, setDetailStep, activeMedicalHealthInformation, setFhirIdForUnmask } =
    useMedicalHealthInformationContext();
  const handleCardClick = (data: Condition) => {
    setFhirIdForUnmask(`Condition/${data.id}`);
    setDetailStep(MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME);
    setActiveStep(MEDICAL_HEALTH_INFORMATION_DETAIL_NAME);
  };

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            {activeMedicalHealthInformation.condition_list.map((data) => {
              return (
                <Card key={data.id} onClick={() => handleCardClick(data)} label={data.name} status={ALREADY_ANSWERED} />
              );
            })}
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationBranchCondition;
